<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>设备用户绑定列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>设备用户绑定列表</span>
        </div>
        <span class="xcx-add left font14" @click="reback()">返回列表</span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border size="mini" :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="nickname" label="昵称" width="160"></el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="title" label="绑定车型"></el-table-column>
          <el-table-column prop="devid" label="设备ID" width="100"></el-table-column>
          <el-table-column prop="dev_id" label="模组ID" width="120"></el-table-column>
          <el-table-column label="主账号" width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_host == 1" type="success" :underline="false">是</el-tag>
              <el-tag v-else type="info" :underline="false">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="unbind_time" label="解/绑日期" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.unbind_time">{{ scope.row.unbind_time }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success" :underline="false">已绑定</el-tag>
              <el-tag v-else-if="scope.row.status == 2" type="info" :underline="false">已解绑</el-tag>
              <el-button size="small" v-else type="warning" @click="setStatus(scope.row)">待审核</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'host')">设为管理员</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'bind')">解绑</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
      },
      devid: 0,
      userid: 0,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.devid = query.id;
    }
    if (query.uid) {
      that.userid = query.uid;
    }
    that.getList();
  },
  methods: {
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "host":
          this.setHost(command.row);
          break;
        case "bind":
          this.del_item(command.row);
          break;
      }
    },
    /** 审核 */
    setStatus(row) {
      var that = this;
      this.$confirm("确定审核通过吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios.post("/dev/bind_status", { id: row.id }).then((res) => {
          that.getList();
        });
      });
    },

    /** 审核 */
    setHost(row) {
      var that = this;
      this.$confirm("确定设为主账号吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios.post("/dev/set_host", { id: row }).then((res) => {
          that.getList();
        });
      });
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("/dev/destroy_bind", {
            ids: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.devid = that.devid;
      formData.userid = that.userid;
      that.axios.post("/dev/devbind", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    reback() {
      if (this.userid) {
        this.$router.push("/users/index");
      } else {
        this.$router.push("/dev/rundev");
      }
    },

  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>